import { reactive, watch, toRefs } from '@vue/composition-api'
import { getBase64 } from '@/utils/util'

const tailorType = {
  app_picture_one: 'app_picture_cut_one',
  app_picture_two: 'app_picture_cut_two',
  app_picture_three: 'app_picture_cut_three',
}

const imgField = ['smeta', 'thumbimage', 'banner', 'app_picture_one', 'app_picture_two', 'app_picture_three']

const byte = 1024 * 2 * 1024

export default () => {
  const state = reactive({
    smetaList: [], // 文章图片
    thumbimageList: [], // 缩略图
    bannerList: [], // banner图

    app_picture_oneList: [],
    app_picture_twoList: [],
    app_picture_threeList: [],

    previewImage: '', // 图片预览
    previewVisible: false, // 图片预览
    cropperVisible: false, // 裁剪弹窗
    tailorType: '', // 裁剪图片类型
    tailorImg: '' // 暂存裁剪图片
  })

  const methods = {
    // 裁剪
    handleTailor(type) {
      if (!this.form[type]) return this.$message.warning('请先上传图片！')
      state.tailorType = type
      state.tailorImg = `${this.form.qi_niu_domains}/${this.form[type]}`
      state.cropperVisible = true
    },

    // 裁剪结束
    handleTailorOver({ path, url }) {
      this.form[`${tailorType[state.tailorType]}`] = path
      state.cropperVisible = false
      state.tailorType = ''
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },

    handleBeforeUpload(file, type) {
      const size = file.size
      const ends = file.name.substring(file.name.lastIndexOf('.') + 1)
      if ((size > byte) || !['jpg', 'jpeg', 'png'].includes(ends)) {
        if (size > byte) {
          this.$message.warning('图片超出2M咯!')
        } else {
          this.$message.warning('图片格式不正确!')
        }
        setTimeout(() => {
          if (type.includes('indexList')) {
            const [ origin, index, types ] = type.split('_')
            this[`${types}List`] = []
          }
          this[`${type}List`] = []
        })
        return false
      }
      return true
    },

    handleChange(type, { file, fileList }) {
      const status = fileList[0]?.status
      this[`${type}List`] = fileList
      if (status === 'done') {
        this.form[type] = fileList[0].response.data.url
        this.$refs.formDom.validateField(type)
      } else {
        this.form[type] = ''
      }
    },

    hadnleDeleteCut(type) {
      this.form[type] = ''
    },

    handleEchoImg(data) {
      for (const key in data) {
        const item = data[key]
        if (imgField.includes(key) && item) {
          state[`${key}List`].push({ uid: Date.now(), name: `${Date.now()}`, status: 'done', url: `${this.form.qi_niu_domains}/${item}` })
        }
      }
    },

    // 关闭预览
    handleCancle() {
      this.previewVisible = false
    },
    // 关闭裁剪
    handleCut() {
      this.cropperVisible = false
    },
  }

  return {
    ...toRefs(state),
    ...methods
  }
}
